import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

// @material-ui/icons
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// custom
import styles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";


const CustomRadioGroup = ({
    classes,
    color,
    size = "sm",
    row,
    formControlProps,
    floatingLabelText,
    name,
    disableError = false,
    error,
    success,
    helpText,
    input,
    meta,
    selectOptions,
}) => {
    const isError = error || (meta && meta.touched && meta.error ? true : false);
    const errorMsg = (meta && meta.touched && meta.error) || helpText;

    const floatingLabelClasses = classNames({
        [classes[size]]: size,
        [classes.floatingLabel]: true,
        [classes.labelRootError]: isError,
        [classes.labelRootSuccess]: success && !isError
    });

    var helpTextClasses = classNames({
        [classes[size]]: size,
        [classes.helpText]: true,
        [classes.labelRootError]: isError,
        [classes.labelRootSuccess]: success && !isError
    });

    return (
        <FormControl {...formControlProps} className={"fullWidthIE"}>
            {/* Floating Label */}
            { floatingLabelText !== undefined ? (
                <FormLabel
                    className={floatingLabelClasses}
                    classes={{
                        root: classes.labelRoot,
                        focused: classes[color+"Color"]
                    }}
                >
                    {floatingLabelText}
                </FormLabel>
            ) : null}

            {/* 라디오버튼 */}
            <RadioGroup
                name={name}
                {...input}
                onChange={(event, value) => input.onChange(value)}
                row={row}
            >
                { selectOptions.map( option => (
                    <FormControlLabel
                        key={`${name}_${option.value}`}
                        control={
                        <Radio
                            icon={
                                <FiberManualRecord 
                                    className={classes.radioUnchecked}
                                />
                            }
                            checkedIcon={
                                <FiberManualRecord
                                    className={classNames(classes.radioChecked, classes[color+"Border"])}
                                />
                            }
                            classes={{
                                root: classes[color+"Checked"],
                                checked: classes[color+"Color"]
                            }}
                        />
                        }
                        classes={{
                            //root: classes.radioLabelRoot,
                            label: classes.label
                        }}
                        label={option.text}
                        value={option.value}
                    />

                )) }
            </RadioGroup>

            {/* 에러 혹은 helpText */}
            { disableError !== true && errorMsg &&
                <FormHelperText id={name + "-text"} className={helpTextClasses}>
                    {errorMsg}
                </FormHelperText>
            }
        </FormControl>
    );
}

CustomRadioGroup.defaultProps = {
    color: "primary"
};

CustomRadioGroup.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "danger",
        "darkblue"
    ]),
    floatingLabelText: PropTypes.node,
    name: PropTypes.string,
    formControlProps: PropTypes.object,
    error: PropTypes.bool,
    success: PropTypes.bool,
    helpText: PropTypes.node,
    selectOptions: PropTypes.array,
    row: PropTypes.bool,
};

export default withStyles(styles)(CustomRadioGroup);